<template lang="pug">
form-item-wrapper(v-bind="bind", :showMessage="false", :rules="rules", :class="formItemClass")
  span {{ curFolderStr || "（无）" }} {{ options.specKey }}
  i.icon-btn.el-icon-edit-outline(v-if="isEdit", @click="openHandler")
  i.icon-btn.el-icon-delete(v-if="isEdit", @click="clearHandler")
</template>

<script>
import { mapVFAssignField, staticMixins } from "@/CommonDP/VForm/utils";
import { openDoc } from "@/CommonDP/components/custom-dialog";
import { DIR_FOLDER_LIMIT, DIR_ROOT } from "./index";
import docService from "@/CommonDP/service/doc-service";

export default {
  mixins: [staticMixins],
  props: {},
  data() {
    return {
      select: [],
      curFolderStr: ""
    };
  },
  computed: {
    ...mapVFAssignField("folderName", "folderNamePath", "folderIdPath")
  },
  watch: {
    fieldModel: {
      handler(nl, ol) {
        nl && this.getDetail(nl);
      },
      immediate: true
    }
  },
  methods: {
    async openHandler() {
      this.preventPreview();
      this.preventDesign();
      if (!this.isEdit) {
        return;
      }
      const rootId = this.options.folderId;
      const rootFolderName = Object.values(DIR_ROOT).find(({ VALUE }) => VALUE === rootId)?.LABEL;
      const props = {
        filter: this.folderFilter,
        queryRoot: this.queryRoot,
        title: rootFolderName || "选择目录",
        check: this.getFolderDisableFilter()
      };
      props.prjId = this.prjId;
      props.showTable = false;
      props.width = "514px";
      props.multiple = false;
      const list = await openDoc(props);
      list.forEach((it) => {
        it.absolutPathName = it.fullName.replaceAll("/", " / ");
        it.absolutPathId = it.fullIdPath;
      });
      this.updateFolder(list);
      this.emitValidate();
    },
    openDirHandler() {
      this.$warn("暂不支持");
    },
    clearHandler() {
      this.updateFolder([]);
      this.emitValidate();
    },
    folderFilter(Vo) {
      const isFolder = Vo.folderId !== "recycle" && Vo.isFolder;
      if (!isFolder) return false;
      const specKey = this.options.specKey;
      if (!specKey) return true;
      const spec = this.curFieLdForm[specKey];
      return Vo.specId === "0" || spec === Vo.specId; // 过滤专业
    },
    getFolderDisableFilter() {
      const limitType = this.options.limitFolder;
      switch (limitType) {
        case DIR_FOLDER_LIMIT.NONE.VALUE:
          return () => true;
        case DIR_FOLDER_LIMIT.NOT_SYS.VALUE:
          return (Vo) => Vo.isSys !== 1;
        case DIR_FOLDER_LIMIT.LAST.VALUE:
          return (Vo) => {
            return Vo.childFolder === 0;
          };
        default:
          return () => true;
      }
    },
    updateAssignValue() {
      this.curFolderStr = this.getFolderData("absolutPathName");
      this.folderName = this.getFolderData("folderName");
      this.folderNamePath = this.curFolderStr;
      this.folderIdPath = this.getFolderData("absolutPathId");
    },
    setCurFieldFormValue(key, value) {
      if (key) {
        if (key) {
          this.curFieLdForm[key] = value;
        }
      }
    },
    async queryRoot() {
      const params = {
        folderId: this.options.folderId,
        isRead: 1,
        priviAll: "1",
        noRightClickMenu: true,
        prjId: this.prjId
      };
      const { data } = await docService.queryTree(params);
      return data.map(item => {
        const { childFolder = 0 } = item;
        return {
          ...item,
          leaf: childFolder === 0
        };
      });
    },
    getFolderData(key) {
      if (this.select?.length === 1) {
        return this.select[0][key];
      } else {
        return "";
      }
    },
    // 触发form数据更新
    updateFolder(value) {
      this.select = value;
      this.fieldModel = value?.[0]?.folderId || "";
      this.updateAssignValue();
    },
    async getDetail() {
      const res = await docService.queryFolderDetail(this.fieldModel);
      this.updateFolder([res.data]);
    }
  }
};
</script>

<style scoped lang="scss">
.icon-btn {
  margin-left: 16px;
  cursor: pointer;
}
</style>
